import { FormControl, FormGroup } from '@angular/forms';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import {
  DialogTypeEnum,
  IDialogConfirm
} from '../../../models/dialog';
import { ILot, LotStatus } from '../../../models/generic';
import { ApiDialogService } from '../../../services/api/api-cdialog.service';
import { ApiLotDetailService } from '../../../services/api/api-lot-detail.service';
import { StatusBadgeTone } from '../status-badge/status-badge.component';
import { batchStatusTone } from 'src/app/shared/utils/status-badge.util';

@Component({
  selector: 'app-card-lotes-faturamento',
  templateUrl: './card-lotes-faturamento.component.html',
  styleUrls: ['./card-lotes-faturamento.component.scss']
})
export class CardLotesFaturamentoComponent implements OnChanges {
  @Input() lote!: ILot;

  LotStatus = LotStatus;

  lotStatus: string = '';
  lotsForm!: FormGroup;

  constructor(
    private _dialogService: ApiDialogService,
    private _lotDetailService: ApiLotDetailService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.buildForm();
    this.lotStatus = this.lote.StatusOfOnlending?.toLowerCase().trim() ?? '';

    if (this.lotsForm) {
      this.lotsForm.patchValue(this.lote);
    }
  }

  buildForm(): void {
    this.lotsForm = new FormGroup({
      LotId: new FormControl(null),
      LotStatusPayment: new FormControl(null),
      LotPartner: new FormControl(null),
      LotDate: new FormControl(null),
      LotBank: new FormControl(null),
      LotValueTransfer: new FormControl(null),
      QtdeContracts: new FormControl(null),
      SaleChannel: new FormControl(null),
      StatusTransfer: new FormControl(null),
      Checked: new FormControl(false)
    });
  }

  get statusLabel(): string {
    return (this.lote.IntegrationError && 'Erro') || this.lote.BatchStatus || this.lote.StatusOfOnlending || '-';
  }

  get statusTone(): StatusBadgeTone {
    return batchStatusTone(this.lote.BatchStatus || this.lote.StatusOfOnlending, {
      integrationError: !!this.lote.IntegrationError
    });
  }

  routeToDetails(lotId: string): void {
    if (this.lote.IntegrationError)
      this.openErrorConfirmationDialog(lotId);
    else this._lotDetailService.routeToDetailEvent.next({ lotId, type: 'Automatic' });
  }

  openErrorConfirmationDialog(lotId: string): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Erro de integração',
        title: `${this.lote.IntegrationMsg || '-'}`,
        confirm: 'Editar',
        dismiss: 'Voltar'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this._lotDetailService.routeToDetailEvent.next({ lotId, type: 'Automatic' });
      }
    });
  }
}